import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const ChevronLeftOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" transform="translate(8 6)" id="a" d="M7 .705a.996.996 0 0 0-1.41 0L1 5.295a.996.996 0 0 0 0 1.41l4.59 4.59A.996.996 0 1 0 7 9.885l-3.88-3.89L7 2.115c.39-.39.38-1.03 0-1.41z" />
  </SvgIcon>
);
